import { render } from "./ContractSinglePage.vue?vue&type=template&id=6ea4d82a&scoped=true"
import script from "./ContractSinglePage.vue?vue&type=script&lang=js"
export * from "./ContractSinglePage.vue?vue&type=script&lang=js"

import "./ContractSinglePage.vue?vue&type=style&index=0&id=6ea4d82a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea4d82a"]])

export default __exports__